// extracted by mini-css-extract-plugin
export default {"icon":"commonModal_icon__M1BTR","scroller":"commonModal_scroller__XUVnP"};